import { render } from "./App.vue?vue&type=template&id=525cd3ab"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=525cd3ab&lang=css"

import exportComponent from "J:\\web2023\\h5\\nav\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__